module.exports = __webpack_public_path__ + "static/media/close_icon.887da8ff.svg";